import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraActionList } from '@mono/ui-components/captains';
import { SpecraText } from '@mono/ui-components/ensigns';
import { SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { rfiQuestionHref } from '../../../components/RecordShell/rfiNav';
import { renderRouterLink } from '../../../lib/renderRouterLink';
import { useRfiReadiness } from './useRfiAnswerReview';
/**
 * "Ready to submit" (WRT-16): the RFI's open readiness issues as an action
 * list, for the RFI Home (WRT-06 mounts it). Section issues link to their
 * question; incomplete issues come before not-checked ones.
 */ export function RfiReadinessList({ limit = 8, rfiResponseProjectId, routeId }) {
    const readiness = useRfiReadiness(rfiResponseProjectId);
    const issues = [
        ...readiness.data?.issues ?? []
    ].sort((a, b)=>Number(a.state !== 'incomplete') - Number(b.state !== 'incomplete'));
    return /*#__PURE__*/ _jsxs("section", {
        className: "flex flex-col gap-[var(--space-2)]",
        "data-testid": Testids.rfiWorkspace.readinessList,
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                title: "Ready to submit",
                variant: "group"
            }),
            readiness.isLoading ? /*#__PURE__*/ _jsx(SpecraText, {
                size: "body-ui",
                tone: "muted",
                children: "Checking readiness…"
            }) : readiness.isError ? /*#__PURE__*/ _jsx(SpecraText, {
                role: "alert",
                size: "body-ui",
                tone: "danger",
                children: "Readiness could not be checked. Refresh to retry."
            }) : issues.length === 0 ? /*#__PURE__*/ _jsx(SpecraText, {
                size: "body-ui",
                tone: "muted",
                children: "Nothing is blocking the package."
            }) : /*#__PURE__*/ _jsx(SpecraActionList, {
                getItemTestId: ()=>Testids.rfiWorkspace.readinessItem,
                items: issues.slice(0, limit).map((issue, i)=>({
                        id: `${issue.code}-${issue.sourceId}-${i}`,
                        label: issue.explanation,
                        description: issue.sourceLabel,
                        tone: issue.state === 'incomplete' ? 'warning' : 'neutral',
                        href: issue.sectionId ? rfiQuestionHref(routeId, issue.sectionId) : undefined
                    })),
                renderLink: renderRouterLink
            })
        ]
    });
}
